import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import Keycloak from "keycloak-js";
import { inject } from "@angular/core";

export const keycloakInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const keycloak = inject(Keycloak);

  // Check if the request is for the backend API
  const isApiUrl = req.url.startsWith(environment.apiUrl);

  if (!isApiUrl) {
    return next(req);
  }

  return from(keycloak.updateToken(30)).pipe(
    mergeMap(() => {
      const token = keycloak.token;
      if (token) {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next(authReq);
      }
      return next(req);
    })
  );
};
